import instance from './axiosInstance';

export function setLandingPage(reqBody, options = {}, http = instance) {
  return http.post('/default_landing_page', reqBody, options);
}

export function getLandingPage(reqBody, options = {}, http = instance) {
  return http.get('/default_landing_page', { ...options, params: reqBody });
}

export const deleteUserLandingPage = async (http = instance): Promise<any> => {
  const response = await http.delete('/default_landing_page');
  return response.data;
};

export const setCustomerDefaultLandingPage = async (config: any, http = instance): Promise<any> => {
  const response = await http.post(`/manage/default_landing_page`, config);
  return response.data;
};

export const deleteCustomerDefaultLandingPage = async (
  config: any,
  http = instance,
): Promise<any> => {
  const response = await http.delete(`/manage/default_landing_page`, {
    data: config,
  });
  return response.data;
};

export const getCustomerDefaultLandingPage = async (http = instance): Promise<any> => {
  const response = await http.get(`/manage/default_landing_page`);
  return response.data;
};
